(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('ProcedureModifierSearch', ProcedureModifierSearch);

    ProcedureModifierSearch.$inject = ['$resource'];

    function ProcedureModifierSearch($resource) {
        var resourceUrl =  'api/_search/procedure-modifiers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
